// Generated by CoffeeScript 2.7.0
var Sortable;

Sortable = class Sortable {
  constructor(element1, options) {
    this.element = element1;
    this.options = options;
    this.init();
  }

  init() {
    var i, len, method, methods;
    methods = ['mousedown', 'mousemove', 'mouseup', 'dragEnd', 'scroll'];
    for (i = 0, len = methods.length; i < len; i++) {
      method = methods[i];
      this[method] = this[method].bind(this);
    }
    return this.bindEvents();
  }

  bindEvents() {
    return this.element.addEventListener('mousedown', this.mousedown, false);
  }

  unbindEvents() {
    return this.element.removeEventListener('mousedown', this.mousedown, false);
  }

  mousedown(event) {
    event.stopPropagation();
    // 不是左键
    if (event.which !== 1) {
      return;
    }
    // 如果不是在dragarea区域内
    if (!event.target.closest(this.options.dragarea)) {
      return;
    }
    this.item = event.target.closest(this.options.item);
    this.scrollContainer = this._getScrollContainer(this.element);
    if (this.item && this.element.contains(this.item)) {
      this._setStartState(event);
      this.scrollContainer.addEventListener('scroll', this.scroll, false);
      window.addEventListener('mousemove', this.mousemove, false);
      return window.addEventListener('mouseup', this.mouseup, false);
    }
  }

  mousemove(event) {
    this._delta = event.clientY - this.startY;
    if (Math.abs(this._delta)) {
      // 首次move记录下一些特殊的东西
      if (!this.moved) {
        this.moved = true;
        document.body.addClass('draging');
        this.item.addClass('draging');
        this.itemHeight = this.item.getBoundingClientRect().height;
      }
      return this._dragMove();
    }
  }

  mouseup(event) {
    // mouseup事件内无法阻止默认的click事件触发，需要将move标记传达出去供外部判断
    if (this.moved) {
      this.item.setAttribute('moved', true);
    } else {
      this.item.removeAttribute('moved');
    }
    this._removeStates();
    this._moveSelf(this.deltaY);
    this.item.addEventListener('transitionend', this.dragEnd, false);
    this.scrollContainer.removeEventListener('scroll', this.scroll, false);
    window.removeEventListener('mousemove', this.mousemove, false);
    return window.removeEventListener('mouseup', this.mouseup, false);
  }

  dragEnd(event) {
    this.item.removeEventListener('transitionend', this.dragEnd, false);
    this.item.removeClass('dragend');
    this.item.removeAttribute('moved');
    _.each(this.items, this._clearStyle);
    this.options.sortChangedFunc(this.startIndex, this.startIndex + this.delta_index);
    return this._setMovedStates();
  }

  scroll(event) {
    return this._dragMove();
  }

  updateScrollTop(dir) {
    var delta, new_scrollTop, scrollTop;
    delta = dir === 'top' ? -8 : 8;
    scrollTop = this.scrollContainer.scrollTop + delta;
    new_scrollTop = Math.max(0, scrollTop);
    this._move(this._delta + new_scrollTop - this.scrollTop);
    return this.scrollContainer.scrollTop = new_scrollTop;
  }

  _clearStyle(element) {
    // 释放所有移动过的item（不包含拖动的当前item）的变换，交由sortChangedFunc去更改拖动后的dom顺序
    element.removeAttribute('style');
    // 释放样式时应取消掉过渡效果以优化性能
    element.style.transition = 'none';
    return setTimeout(function() {
      // sortChangedFunc 函数执行完毕后再恢复去掉的过渡效果
      return element.removeAttribute('style');
    }, 0);
  }

  _dragMove() {
    var outRangeDir;
    outRangeDir = this._isOutOfRange();
    if (outRangeDir) {
      return this.updateScrollTop(outRangeDir);
    } else {
      return this._move(this._delta + this.scrollContainer.scrollTop - this.scrollTop);
    }
  }

  _isOutOfRange() {
    var item_rect, scroll_rect;
    item_rect = this.item.getBoundingClientRect();
    scroll_rect = this.scrollContainer.getBoundingClientRect();
    if (item_rect.top < scroll_rect.top) {
      return 'top';
    } else {
      // 如果拖动的元素高度超过了滚动容器的一半
      if (item_rect.height > scroll_rect.height / 2) {
        if (item_rect.top > scroll_rect.bottom - 100) {
          return 'bottom';
        } else {
          return false;
        }
      } else {
        if (item_rect.bottom > scroll_rect.bottom) {
          return 'bottom';
        } else {
          return false;
        }
      }
    }
  }

  _move(delta) {
    this._moveSelf(delta);
    return this._moveOthers(delta);
  }

  _setStartState(event) {
    this.startY = event.clientY;
    this.scrollTop = this.scrollContainer.scrollTop;
    this.items = _.filter(this.element.querySelectorAll(this.options.item), (item) => {
      // 只判断当前拖动元素的兄弟
      return item.parentElement === this.item.parentElement;
    });
    return this.startIndex = _.indexOf(this.items, this.item);
  }

  _moveSelf(delta) {
    return _.extend(this.item.style, {
      transform: `translateY(${delta}px)`,
      webkitTransform: `translateY(${delta}px)`
    });
  }

  _setMovedStates() {
    this.delta_index = 0;
    return this.deltaY = 0;
  }

  _moveOthers(delta) {
    var iterate_attr, iterate_dir, iterate_item, iterate_item_height, transforms;
    this._setMovedStates();
    if (delta === 0) {
      return;
    }
    if (delta > 0) {
      iterate_attr = 'nextElementSibling';
      iterate_dir = 1;
    } else {
      iterate_attr = 'previousElementSibling';
      iterate_dir = -1;
    }
    iterate_item = this.item[iterate_attr];
    transforms = {
      transform: `translateY(${-iterate_dir * this.itemHeight}px)`,
      webkitTransform: `translateY(${-iterate_dir * this.itemHeight}px)`
    };
    while (iterate_item && ((iterate_dir > 0 && delta > iterate_item.getBoundingClientRect().height / 2) || (iterate_dir < 0 && delta < -iterate_item.getBoundingClientRect().height / 2))) {
      iterate_item_height = iterate_item.getBoundingClientRect().height;
      this.delta_index += iterate_dir;
      this.deltaY += iterate_dir * iterate_item_height;
      _.extend(iterate_item.style, transforms);
      delta = delta - iterate_dir * iterate_item_height;
      iterate_item = iterate_item[iterate_attr];
    }
    // 解决回拉时的判断错误问题
    if (iterate_item) {
      return iterate_item.removeAttribute('style');
    }
  }

  _removeStates() {
    delete this.moved;
    delete this.startY;
    delete this._delta;
    delete this.scrollTop;
    this.item.removeClass('draging');
    this.item.addClass('dragend');
    return document.body.removeClass('draging');
  }

  _getScrollContainer(element) {
    while (!/scroll|auto/.test(getComputedStyle(element).overflowY)) {
      if (element === document.body) {
        break;
      }
      element = element.parentElement;
    }
    return element;
  }

};

Vue.directive('sortable', {
  bind: function(el, binding, vnode, oldVnode) {
    return new Sortable(el, binding.value);
  }
});
